// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2XL3J","tab":"Tabs_tab__1s6OL","tabActive":"Tabs_tabActive__m8mue"};